import script from "./JITSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./JITSidebar.vue?vue&type=script&setup=true&lang=js"

import "./JITSidebar.vue?vue&type=style&index=0&id=6999a776&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6999a776"]])

export default __exports__